$(document).ready(function() {
  if ($('.p-resource').length) {
    $('.p-resource .load-more').click(function(e) {
      e.preventDefault();
      $('.p-resource .load-more-resources').removeClass('d-none');
      $(this).addClass('d-none');
    });
  }
});
